import Progress from "rsuite/Progress";
import {useEffect} from "react";


const FastButtonsBlock = ({ methodPayment, setAmountDeposit, bonusLine, amountDeposit, setBonusLine, rateCurrency }) => {

    //подсветка синим активного бонуса
    const lastActive = methodPayment?.buttonsData
        ?.map((btn, i) => ({ ...btn, index: i }))
        .filter(btn => amountDeposit >= btn.sum)
        .pop();

    const lastActiveIndex = lastActive?.index ?? null;

    useEffect(() => {
        if (lastActive) {
            setBonusLine(lastActive.line);
        } else {
            setBonusLine(0); // сбросить значение, если ничего не подошло
        }
    }, [lastActive]);

    return (
        <div className="fast-buttons">
            <div className="start-bonus-buttons">
                { methodPayment?.buttonsData.map((btn, index) => (
                    <div key={index} className="fast-amount-block d-flex flex-direction-column">
                        <button onClick={() => setAmountDeposit(btn.sum)}  className={`fast-amount ${ index === lastActiveIndex && "active"}`}>
                            <span className="fast-amount-text">{ btn.info }</span>
                        </button>
                    </div>
                ))}
            </div>
            <Progress.Line
                style={{background: "#51545b", borderRadius: "10px"}}
                strokeColor={"linear-gradient(90deg, #4046eb, #1a8bff)"} strokeWidth={5}  percent={bonusLine || 0}
                status="active" showInfo={false}
            />
            <div className="start-bonus-buttons">
                { methodPayment?.buttonsData.map((btn, index) => (
                    <div key={index} className="fast-amount-block d-flex flex-direction-column">
                        <span className={`fast-amount-sum ${bonusLine === btn.line ? "active" : "" }`}>{ btn.sum } { methodPayment?.iconCurrency }</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FastButtonsBlock;